export default "__VITE_ASSET__D6O018n7__"